module.exports = "/images/vendor/desiigner-svg/svg/postal.svg?328c6b0cb74e4b028aa5075f980a58df";